import {request} from './base'

export default {
    queryPage(params) {
        return request('/cabinet/queryPage', params, 'get')
    },
    queryCellListById(param) {
        return request('/cabinet/queryCellListById', param, 'get')
    }
}
